import * as Actions from './actions';

export function quotationReducer(state = null, action) {
  switch (action.type) {
    case Actions.FETCH_CUSTOMER_QUOTATION:
      return null;
    case Actions.QUOTATION_RETRIEVED:
      return action.quotation;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/SFQuotationService/reducers.js